import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'

interface IUserMobile {
  /**
   * 手机号码
   *
   * @type {string}
   * @memberof IUserMobile
   * @example {'mobile': '15858264900'}
   */
  mobile: string
}

interface IUserMobileResponse {
  success?: (result: IUserMobile) => void
  fail?: (result: IUserMobile) => void
  complete?: (result: IUserMobile) => void
}

/**
 * 获取手机号
 *
 * @param {IBridgeOptions<IUserMobileResponse>} { success, fail, complete }
 */
function getUserMobileSync({ success, fail, complete }: IBridgeOptions<IUserMobileResponse>) {
  const params = formatParams({
    funType: 'userInfo',
    funName: 'getUserMobile'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('getUserMobile error: ', error)
  }
}

/**
 * 获取用户手机号<br>
 * 一个异步接口，支持 Promise 化使用
 *
 * @returns {Promise<IUserMobile>}
 */
function getUserMobile(): Promise<IUserMobile> {
  const params = formatParams({
    funType: 'userInfo',
    funName: 'getUserMobile'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }

  return nativeJSBridge(opts)
}

export { getUserMobile, getUserMobileSync }
